import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f726252"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "reportForm"
};
var _hoisted_2 = {
  class: "hostSummary"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "hostSummary"
};
var _hoisted_6 = {
  class: "box"
};
var _hoisted_7 = {
  class: "tab"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "hostSummary"
};
var _hoisted_10 = {
  class: "box"
};
var _hoisted_11 = {
  class: "tab"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "hostSummary"
};
var _hoisted_14 = {
  class: "hostSummary"
};
var _hoisted_15 = {
  class: "rankList"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_date_header_with_btn = _resolveComponent("date-header-with-btn");
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_line_echart = _resolveComponent("line-echart");
  var _component_rank_list_item = _resolveComponent("rank-list-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_type_tab, {
    typeTabs: ['日', '周', '月', '自定义'],
    onConfirmType: _ctx.confirmType
  }, null, 8, ["onConfirmType"]), _createVNode(_component_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    showBtn: false,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["type", "onConfirmDate"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "销售总汇"
  }), _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(item.value), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_c_title, {
    title: "各料类销售占比"
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTab,
        tabActiveLeft: item === '销量' && item === _ctx.curTab,
        tabActiveRight: item === '金额' && item === _ctx.curTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_8);
  }), 128))])]), _ctx.categorySaleCount.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.categorySaleCount)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1,
    text: "暂无数据"
  })), _ctx.categorySaleCount.pieData.length ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "data-more",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.toSaleFormProp && _ctx.toSaleFormProp.apply(_ctx, arguments);
    })
  }, " 查看全部 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_ctx.outweighOneDay ? (_openBlock(), _createBlock(_component_c_title, {
    key: 0,
    title: "各日营收趋势"
  })) : (_openBlock(), _createBlock(_component_c_title, {
    key: 1,
    title: "各时段营收趋势"
  })), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTabS,
        tabActiveLeft: item === '销量' && item === _ctx.curTabS,
        tabActiveRight: item === '金额' && item === _ctx.curTabS
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClickS(item);
      }
    }, _toDisplayString(item), 11, _hoisted_12);
  }), 128))])]), _ctx.revenueCount.lineData.length ? (_openBlock(), _createBlock(_component_line_echart, _normalizeProps(_mergeProps({
    key: 2
  }, _ctx.revenueCount)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 3,
    text: "暂无数据"
  }))]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_c_title, {
    title: "支付方式占比"
  }), _ctx.payRtoPie.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.payRtoPie)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1,
    text: "暂无数据"
  }))]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_c_title, {
    title: "销售排行"
  }), _createElementVNode("div", _hoisted_15, [_ctx.saleRank.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.saleRank, function (item, index) {
    return _openBlock(), _createBlock(_component_rank_list_item, {
      key: index,
      type: "shangtong",
      item: item,
      index: index
    }, null, 8, ["item", "index"]);
  }), 128)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])])]);
}